export var PNLErrorEnum;
(function (PNLErrorEnum) {
    PNLErrorEnum["ERROR_DATA"] = "errorData";
    PNLErrorEnum["DOWNLOADSTATUS"] = "downloadStatus";
    PNLErrorEnum["EMAILSTATUS"] = "emailStatus";
    // TXNSTATUS = "txnStatus",
})(PNLErrorEnum || (PNLErrorEnum = {}));
export var PNLTransactionErrorEnum;
(function (PNLTransactionErrorEnum) {
    PNLTransactionErrorEnum["ERROR_DATA"] = "errorData";
    PNLTransactionErrorEnum["TXNSTATUS"] = "txnStatus";
    PNLTransactionErrorEnum["ORGTXN"] = "orgTxnStatus";
})(PNLTransactionErrorEnum || (PNLTransactionErrorEnum = {}));
